export default __webpack_public_path__ + "6c61b0d3e08a30586972c19b6a1124f4.jpg";